import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { getUserCredits } from "actions/CreditsAction";
import { Badge } from "react-bootstrap";

const CREDITS_REFRESH_INTERVAL_MS = 30000;

function CreditsLabel({ autoReload = false }) {
  const [credits, setCredits] = useState(0);

  useEffect(() => {
    let isMounted = true;
    let isLoading = false;

    const loadCredits = () => {
      if (isLoading) {
        return;
      }

      isLoading = true;

      getUserCredits()
        .then(response => {
          if (!isMounted) {
            return;
          }

          console.log("CreditsLabel: got user credits", response);
          setCredits(response.credits);
        })
        .catch(err => {
          console.error("CreditsLabel: error getting user credits", err);
        })
        .finally(() => {
          isLoading = false;
        });
    };

    loadCredits();

    if (autoReload) {
      const intervalId = window.setInterval(() => {
        if (document.visibilityState === "hidden") {
          return;
        }

        loadCredits();
      }, CREDITS_REFRESH_INTERVAL_MS);

      return () => {
        isMounted = false;
        window.clearInterval(intervalId);
      };
    }
  }, []);

  const redirectToBuyCredits = () => {
    window.location.href = "/de/account/digitalproducts";
  };

  return (
    <Badge className="credits-label text-uppercase" variant="primary" onClick={redirectToBuyCredits} style={{ cursor: "pointer" }}>
      {credits} {credits !== 1 ? "credits" : "credit"}
    </Badge>
  );
}

export default CreditsLabel;